var map = {
	"./SidebarPlugin": "c2a6",
	"./SidebarPlugin/": "c2a6",
	"./SidebarPlugin/SideBar": "3e77",
	"./SidebarPlugin/SideBar.vue": "3e77",
	"./SidebarPlugin/SidebarLink": "fcd4",
	"./SidebarPlugin/SidebarLink.vue": "fcd4",
	"./SidebarPlugin/index": "c2a6",
	"./SidebarPlugin/index.js": "c2a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "047e";